import React, { useEffect, useState } from "react";

const FiltersComment = ({
  reviews,
  filteredReviews,
  expertFilter,
  searchTerm,
  sortOption,
  onFilterChange,
  onSortChange,
  onSearchChange,
  total,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [activeSortOption, setActiveSortOption] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/comments/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  const uniqueExperts = [
    ...new Set(
      (reviews || [])
        .filter((r) => r.expert?.nickname)
        .map((r) => r.expert.nickname.toLowerCase()),
    ),
  ].map((nickname) => {
    const reviewFound = reviews.find(
      (review) => review.expert.nickname.toLowerCase() === nickname,
    );
    return reviewFound?.expert?.nickname;
  });

  const handleExpertSelect = (event) => {
    const expert = event.target.value;
    setSelectedExpert(expert);
    onFilterChange(expert === "" ? null : expert);
  };

  const handleSortOptionClick = (optionName) => {
    if (activeSortOption === optionName) {
      setActiveSortOption(null);
      onSortChange(null);
    } else {
      setActiveSortOption(optionName);
      onSortChange(optionName);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onSearchChange(value);
  };

  const handleReset = () => {
    setSelectedExpert("");
    setActiveSortOption(null);
    setSearchValue("");
    onFilterChange(null);
    onSortChange(null);
    onSearchChange("");
  };

  const shouldHideResetButton = !selectedExpert && activeSortOption === null;

  return (
    <div className="col-xl-12 text-start">
      <div className="row g-3 align-items-stretch">
        <div className="custom-card col-12 col-md-6 col-lg-4 d-flex mb-3 w-100">
          <div className="card-body p-0">
            <nav
              className="navbar navbar-expand-xxl bg-white w-100"
        
            >
              <div className="container">
                <div className="d-flex justify-content-between align-items-center f-w-100">
                  <h6 className="mb-0 me-3 text-muted">
                    {languageData.filter} :
                  </h6>
                  <button data-interaction="filter_collapse_button"
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </div>
                <div
                  className="collapse navbar-collapse navbar-justified"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav me-auto align-items-xxl-center gap-5">
                    <li className="nav-item">
                      <select
                        className="form-select"
                        value={selectedExpert || ""}
                        onChange={handleExpertSelect}
                      >
                        <option value="">{languageData.all}</option>
                        {uniqueExperts.map((expert) => (
                          <option key={expert} value={expert} data-interaction="dropdown_filter_comment">
                            {expert}
                          </option>
                        ))}
                      </select>
                    </li>

                    <div className="d-flex me-2" role="search">
                      <input
                        className="form-control form-control-sm me-6"
                        type="search"
                        name="search"
                        placeholder={languageData.search}
                        aria-label="Search"
                        value={searchValue}
                        onChange={handleSearchChange}
                      />
                    </div>

                    <li
                      className="nav-item dropdown ml-1"
                    >
                      <button data-interaction="sort_button"
                        className="btn btn-sm btn-primary-light dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        {languageData.sort}
                      </button>
                      <ul className="dropdown-menu">
                        {["rating", "newest"].map((sortOption) => (
                          <li key={sortOption}>
                            <a data-interaction="sort_dropdown"
                              className={`dropdown-item ${
                                activeSortOption === sortOption ? "active" : ""
                              }`}
                              onClick={() => handleSortOptionClick(sortOption)}
                            >
                              {languageData[`sort_${sortOption}`]}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                    {!shouldHideResetButton && (
                      <li className="nav-item">
                        <button data-interaction="reset_filter_button"
                          className="btn btn-sm btn-outline-secondary reset_filter"
                          onClick={handleReset}
                        
                        >
                          {languageData.reset || "Reset"}
                        </button>
                      </li>
                    )}
                  </ul>
                  {languageData.total}:{" "}
                  {(expertFilter || searchTerm || sortOption) &&
                  filteredReviews.length > 0
                    ? `${filteredReviews.length} / ${total}`
                    : `${reviews.length} / ${total}`}
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersComment;
